import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav, Container, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import logo from '../imgs/temporary-logo-3.png';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <BootstrapNavbar expand="lg" bg='dark' data-bs-theme="dark">
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/gallery">
          <img src={logo} alt="Logo" style={{ height: '40px', marginRight: '10px' }} />
        
        </BootstrapNavbar.Brand>
        
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/gallery">Galeria</Nav.Link>
            {user && !isAdmin() && (
              <Nav.Link as={Link} to="/dashboard">Meus PDFs</Nav.Link>
            )}
            {user && isAdmin() && (
              <Nav.Link as={Link} to="/admin">Painel Admin</Nav.Link>
            )}
          </Nav>
          
          <Nav>
            {user ? (
              <>
                <BootstrapNavbar.Text className="me-3">
                  Olá, {user.firstName}!
                </BootstrapNavbar.Text>
                <Button variant="outline-light" onClick={handleLogout}>
                  Sair
                </Button>
              </>
            ) : (
              <>
                <Button variant="outline-light" as={Link} to="/login" className="me-2">
                  Entrar
                </Button>
              </>
            )}
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
